import { Pipe, PipeTransform } from '@angular/core';
import { getClientConfig } from '@config/client-config';

@Pipe({
  name: 'faceIdImageUrl',
})
export class FaceIdImageUrlPipe implements PipeTransform {
  private env = getClientConfig().environments;
  transform(url: string): string {
    if (url) return url;
    const noAvatarSvgPath = 'assets/common/no-avatar.svg';
    if (this.env.isGeotabEnv && this.env?.geotabDeployUrl) return `${this.env?.geotabDeployUrl}/${noAvatarSvgPath}`;
    return noAvatarSvgPath;
  }
}
